<template>
  <div class="webapp-box">
    <div class="top-tool">
      <div class="game-logo" :style="{'background-image':cssRequireByLang('/imgs/game-logo.png')}"></div>
      <div class="btn-reservation" :style="{'background-image':cssRequireByLang('/imgs/top-btn.png')}" @click="toReservationUrl"></div>
      <div class="btn-menu" @click="isShowMenu = true"></div>
      <div class="audio-btn" :class="{'play':isPlayBgAudio}" @click="bgAudioClick"></div>
    </div>
    <div class="menu-box" v-if="isShowMenu">
      <div class="menu-list">
        <div class="close"  @click="isShowMenu = false"></div>
        <div class="menu menu1 menu-line" :style="{'background-image':cssRequireByLang('/imgs/menu-1.png')}" @click="moveToPage('page1')"></div>
        <div class="menu menu2 menu-line" :style="{'background-image':cssRequireByLang('/imgs/menu-2.png')}" @click="moveToPage('page2')"></div>
        <div class="menu menu3 menu-line" :style="{'background-image':cssRequireByLang('/imgs/menu-3.png')}" @click="moveToPage('page3')"></div>
        <div class="menu menu4 menu-line" :style="{'background-image':cssRequireByLang('/imgs/menu-4.png')}" @click="moveToPage('page4')"></div>
        <div class="menu menu5" :style="{'background-image':cssRequireByLang('/imgs/menu-5.png')}" @click="moveToPage('page5')"></div>
      </div>
    </div>
    <full-page id="fullpage" :options="options" ref="fullpage">
      <div class="section section1 ">
        <div class="bg-page bg-page-1">
          <div class="page page1">
            <div class="hero"></div>
            <div class="logo-bg">
              <div class="play-btn" @click="videoClick"></div>
            </div>
            <div class="info"></div>
            <div class="reservation-box">
              <a target="_blank" class="download ios-btn " :href="toUrl.ios" @click="downClick(toUrl.ios,true)"></a>
              <a target="_blank" class="download android-btn " :href="toUrl.gp" @click="downClick(toUrl.gp,false)"></a>
            </div>
            <span class="rating"></span>
            <div class="section-next" @click="fullPageNext"></div>
          </div>
        </div>
      </div>
      <div class="section section2">
        <div class="bg-page bg-page-2">
          <div class="page page2">
            <div class="hero"></div>
            <div class="reward" :style="{'background-image':cssRequireByLang('/imgs/reward.png')}">
              <div class="achieved pos1" :style="{'background-image':cssRequireByLang('/imgs/achieved.png')}" v-if="rewardGrade >= 1"></div>
              <div class="achieved pos2" :style="{'background-image':cssRequireByLang('/imgs/achieved.png')}" v-if="rewardGrade >= 2"></div>
              <div class="achieved pos3" :style="{'background-image':cssRequireByLang('/imgs/achieved.png')}" v-if="rewardGrade >= 3"></div>
              <div class="achieved pos4" :style="{'background-image':cssRequireByLang('/imgs/achieved.png')}" v-if="rewardGrade >= 4"></div>
            </div>
            <div class="section-next" @click="fullPageNext"></div>
          </div>
        </div>
      </div>
      <div class="section section3">
        <div class="bg-page bg-page-3">
          <div class="page page3">
            <div class="hero-logo"></div>
            <div class="swiper-box">
              <swiper class="hero-swipe" ref="heroSwipe" :options="heroSwiperOptions">
                <swiper-slide class="hero-slide" v-for="(hero,index) in heroList" :key="index">
                  <img class="hero"  :src="imgRequireByCommon(hero.heroBg.img)" alt="">
                  <img class="info" :src="imgRequireByLang(hero.heroInfo.img)" alt="">
                  <img class="cv" :src="imgRequireByLang(hero.heroCv.img)" alt="" @click="heroAudioCLick(hero.heroCvAudio)">
                </swiper-slide>
              </swiper>
              <div class="hero-swiper-navigation hero-swiper-prev" slot="button-prev"></div>
              <div class="hero-swiper-navigation hero-swiper-next" slot="button-next"></div>
            </div>
            <div class="section-next" @click="fullPageNext"></div>
          </div>
        </div>
      </div>
      <div class="section section4">
        <div class="bg-page bg-page-4">
          <div class="page page4">
            <div class="worldview-box" :style="{'background-image':cssRequireByLang('/imgs/bg-worldview.png')}">
              <div class="worldview-text" :style="{'background-image':cssRequireByLang('/imgs/worldview-text.png')}"></div>
            </div>
            <div class="section-next" @click="fullPageNext"></div>
          </div>
        </div>
      </div>
      <div class="section section5">
        <div class="bg-page bg-page-5">
          <div class="page page5">
            <div class="game-feature-logo" :style="{'background-image':cssRequireByLang('/imgs/game-feature.png')}"></div>
            <div class="swiper-box">
              <swiper class="feature-swipe" ref="featureSwipe" :options="featureSwiperOptions">
                <swiper-slide class="feature-slide" v-for="(feature,index) in featureList" :key="index">
                  <img :src="imgRequireByLang(feature.img)" alt="">
                </swiper-slide>
              </swiper>
              <div class="feature-swiper-navigation feature-swiper-prev" slot="button-prev"></div>
              <div class="feature-swiper-navigation feature-swiper-next" slot="button-next"></div>
            </div>
          </div>
        </div>
      </div>
    </full-page>
    <audio ref="bgAudio" id="bgAudio" autoplay="autoplay" loop="loop" preload="auto">
      <source src="../../../assets/web-firehero/common/audio/bg.ogg" />
      <source src="../../../assets/web-firehero/common/audio/bg.mp3" />
      <source src="../../../assets/web-firehero/common/audio/bg.wav" />
      你的浏览器不支持audio标签
    </audio>
    <audio ref="heroAudio" id="heroAudio" preload="auto">
      <source :src="heroCV.ogg" />
      <source :src="heroCV.map3" />
      <source :src="heroCV.wav" />
      你的浏览器不支持audio标签
    </audio>
    <!-- 视频弹窗 start -->
    <div class="dialog-box" v-if="isPlayVideo" @click="videoClick">
      <div class="dialog-video" @click.stop="console.log('')">
        <video
          src="../../../assets/web-firehero/common/vedio/game.mp4"
          width="100%"
          height="100%"
          autoplay="autoplay"
          controls
          preload></video>
      </div>
    </div>
    <!-- 视频弹窗 end -->
  </div>
</template>

<script>
  import * as config from '@/config';
  import * as datetool from '@/utils/date.js';
  import * as commonTool from '@/utils/common.js';
  import * as webSites from "@/api/webSites.js";
  import WebStorageCache from "web-storage-cache";
  const sessionCache = new WebStorageCache({storage: "sessionStorage"});      //sessionstorage
  import { Swiper,SwiperSlide, directive } from 'vue-awesome-swiper'

  export default {
    components: {
      Swiper,
      SwiperSlide,
    },
    directives: {
      swiper: directive
    },
    data () {
      return {
        commonTool:commonTool,
        webURL:config.FIREHERO_WEBURL,
        webType:"h5",
        curLang:commonTool.getSystemLang(),
        toUrl:{
          fb:config.FIREHERO_DOWN_URL.fb,
          ios:config.FIREHERO_DOWN_URL.ios,
          gp:config.FIREHERO_DOWN_URL.gp,
        },
        heroList:config.FIREHERO_WEBSITE_CONFIG.heroList,
        featureList:config.FIREHERO_WEBSITE_CONFIG.featureList,
        isPlayVideo:false,
        isPlayBgAudio:false,
        isShowMenu:false,
        heroCV:{
          ogg:"",
          map3:"",
          wav:"",
        },
        rewardGrade:0,//预约奖励档次
        screenWidth: document.body.clientWidth,
        featureSwiperOptions: {
          effect : 'fade',
          fadeEffect: {
            crossFade: true,
          },
          watchSlidesProgress: true,
          slidesPerView: 1,
          speed:1000,
          centeredSlides:true,
          loop: true,
          loopedSlides: 1,
          autoplay: true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          navigation: {
            nextEl: '.feature-swiper-next',
            prevEl: '.feature-swiper-prev'
          },
          on: {}
        },
        heroSwiperOptions: {
          effect : 'fade',
          fadeEffect: {
            crossFade: true,
          },
          slidesPerView: 1,
          speed:1000,
          centeredSlides:true,
          loop: true,
          loopedSlides: 1,
          autoplay: true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          navigation: {
            nextEl: '.hero-swiper-next',
            prevEl: '.hero-swiper-prev'
          },
          on: {}
        },
        options: {
          licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
          afterLoad: this.onAfterLoad,
          onLeave: this.onLeave, //滚动前的回调函数，
          scrollOverflow: true,
          navigation: false, //是否显示导航，默认为false
          navigationPosition: 'right', //导航小圆点的位置
          scrollBar: false,
          keyboardScrolling: false, //是否可以使用键盘方向键导航，默认为true
          continuousVertical: false, /// 是否循环滚动，默认为false。如果设置为true，则页面会循环滚动，而不像loopTop或loopBottom那样出现跳动，注意这个属性和loopTop、loopBottom不兼容和，不要同时设置
          touchSensitivity: 5, //在移动设置中页面敏感性，最大为100，越大越难滑动
          menu: '#menu',
          anchors: ['page1', 'page2', 'page3', 'page4', 'page5'],
          lockAnchors: true,
          sectionsColor: []
        }
      }
    },
    watch: {
      screenWidth(val){
        let that = this;
        that.countWebappFontSize();
      }
    },
    computed: {
      heroSwipe() {
        return this.$refs.heroSwipe.$swiper
      },
      featureSwipe() {
        return this.$refs.featureSwipe.$swiper
      }
    },
    updated(){
    },
    created() {
      let that = this;
      if (that.commonTool.isPC()) {
        that.$router.push('/web/firehero');
      }
      (function () {
        document.addEventListener('DOMContentLoaded', function () {
          that.countWebappFontSize();
        }, false);
      })();
    },
    mounted () {
      const that = this;
      let params = {};
      webSites.getRewardByFirehero(params,that.webURL).then(res => {
        let data = res.data;
        if (data.ret === 0 ) {
          that.rewardGrade = data.reward;
        }else {
          that.$toast("error !!!");
        }
      })
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth
          that.screenWidth = window.screenWidth
        })()
      }
    },
    methods:{
      imgRequireByCommon(value){
        return require("../../../assets/web-firehero/common/" + this.webType + value);
      },
      cssRequireByCommon(value){
        return "url(" + this.imgRequireByCommon(value) + ")";
      },
      imgRequireByLang(value){
        return require("../../../assets/web-firehero/" + this.curLang + "/" + this.webType + value);
      },
      cssRequireByLang(value){
        return "url(" + this.imgRequireByLang(value) + ")";
      },
      langSwitch(lang){
        this.isShowLangSelect = false;
        this.curLang = lang;
      },
      countWebappFontSize(){
        //改变html fontsize大小
        // const that = this
        let html = document.documentElement;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let scale = width/height;
        let widthBase = 640;
        let heightBase = 1386;
        let scaleBase = widthBase/heightBase;
        let base = scale > scaleBase ? height:width;
        let a = 0;
        if (scale > scaleBase) {
          //以height作为基础
          a = height*scaleBase /10;
        } else {
          //以width作为基础
          a = width/10;
        }
        html.style.fontSize = a  + 'px';
      },
      onAfterLoad(index, nextIndex, direction){
        if (this.isShowMenu) {
          return false;
        }
      },
      onLeave(index, nextIndex, direction){
        if (this.isShowMenu) {
          return false;
        }
      },
      moveToPage(page){
        this.isShowMenu = false;
        this.$refs.fullpage.api.moveTo(page);
      },
      fullPageNext(){
        this.$refs.fullpage.api.moveSectionDown()
      },
      prev() {
        this.featureSwipe.slidePrev();
      },
      next() {
        this.featureSwipe.slideNext();
      },
      bgAudioClick(){
        if (this.isPlayBgAudio) {
          this.$refs.bgAudio.pause();
          this.isPlayBgAudio = false;
        }else {
          this.$refs.bgAudio.play();
          this.isPlayBgAudio = true;
        }
      },
      videoClick(){
        let that = this;
        if(that.isPlayVideo){
          that.isPlayVideo = false;
          if (this.isPlayBgAudio) {
            this.$refs.bgAudio.play();
          }
        }else {
          that.isPlayVideo = true;
          this.$refs.bgAudio.pause();
        }
      },
      heroAudioCLick (cv) {
        let that = this;
        this.heroCV.ogg = require("../../../assets/web-firehero/common/audio/" + cv + ".ogg");
        this.heroCV.map3 = require("../../../assets/web-firehero/common/audio/" + cv + ".mp3");
        this.heroCV.wav = require("../../../assets/web-firehero/common/audio/" + cv + ".wav");
        this.$refs.heroAudio.load();
        this.$refs.heroAudio.play();
        this.heroSwipe.autoplay.stop();
        this.$refs.heroAudio.onended = function() {
          that.heroSwipe.autoplay.start();
        };
      },
      toReservationUrl(){
        let u = navigator.userAgent, app = navigator.appVersion;
        // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let url = this.toUrl.gp;//默认安卓操作系统
        if (isIOS) {
          //ios操作系统
          url = this.toUrl.ios;
        }
        this.downClick(url,isIOS);
      },
      //下载链接跳转点击事件
      downClick(url,isIOS){
        let that = this;
        that.openUrl(url);
      },
      //gp跟踪代码
      gpClick(url,isIOS){
        let that = this;
        gtag('event', 'conversion', {
          'send_to': 'AW-355221226/kEd4CNSt9ssCEOr9sKkB',
          'event_callback': that.openUrl(url)
        });
      },
      //fb像素代码
      fbPixelClick(url,isIOS){
        fbq('track', 'CompleteRegistration');
        this.openUrl(url);
      },
      openUrl (url) {
        window.open(url, '_blank');
      }
    },
  }
</script>

<style scoped>
.webapp-box{
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.webapp-box .top-tool{
  position: fixed;
  z-index: 99;
  width: 100%;
  height: calc(1.35rem * (75 / 75));
  background-image: url('../../../assets/web-firehero/common/h5/imgs/bg-top-tool.png');
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
}

.webapp-box .top-tool .game-logo{
  position: absolute;
  z-index: 100;
  width: 5.5rem;
  height: calc(5.5rem * (75 / 342));
  background-image: url('../../../assets/web-firehero/zh/h5/imgs/game-logo.png');
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
  top: 10%;
  left: 3.5%;
}

.webapp-box .top-tool .btn-reservation{
  position: absolute;
  z-index: 100;
  width: 1.8rem;
  height: calc(1.8rem * (43 / 106));
  background-image: url('../../../assets/web-firehero/zh/h5/imgs/top-btn.png');
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
  top: 28%;
  left: 62%;
}

.webapp-box .top-tool .btn-menu{
  position: absolute;
  z-index: 100;
  width: 1.2rem;
  height: calc(1.2rem * (75 / 75));
  background-image: url('../../../assets/web-firehero/common/h5/imgs/btn-menu.png');
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
  top: 10%;
  right: 3%;
}

.webapp-box .top-tool .audio-btn{
  position: absolute;
  cursor: pointer;
  width: 1.3rem;
  padding-top: calc(1.3rem * (72 / 76));
  top: 120%;
  right: 3%;
  background-image: url('../../../assets/web-firehero/common/audio/noplay.png');
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
}

.webapp-box .top-tool .audio-btn.play{
  background-image: url('../../../assets/web-firehero/common/audio/play.png');
}

@keyframes menu-show{
  from {opacity: 0;}
  to {opacity:1;}
}

.webapp-box .menu-box{
  position: absolute;
  z-index: 199;
  width: 100%;
  height: 100%;
  background-color: rgba(10, 9, 9, 0.8);
  animation: menu-show 300ms linear;
}

.webapp-box .menu-box .menu-list{
  position: relative;
  width:10rem;
  height: calc(10rem * (1386 / 640));
  margin: 0 auto;
  overflow: hidden;
}

.webapp-box .menu-box .menu-list .close{
  position: absolute;
  z-index: 199;
  width:0.8rem;
  height: calc(0.8rem * (30 / 30));
  background-image: url('../../../assets/web-firehero/common/h5/imgs/menu-close.png');
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
  right: 6%;
  top: 6%;
}

.webapp-box .menu-box .menu-list .menu{
  position: absolute;
  z-index: 199;
  width:1.5rem;
  height: calc(1.5rem * (66 / 85));
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
  -webkit-transform: translateX(-50%);
  left: 50%;
}

.webapp-box .menu-box .menu-list .menu1{
  background-image: url('../../../assets/web-firehero/zh/h5/imgs/menu-1.png');
  top: 20%;
}

.webapp-box .menu-box .menu-list .menu2{
  background-image: url('../../../assets/web-firehero/zh/h5/imgs/menu-2.png');
  top: 30%;
}

.webapp-box .menu-box .menu-list .menu3{
  background-image: url('../../../assets/web-firehero/zh/h5/imgs/menu-3.png');
  top: 40%;
}

.webapp-box .menu-box .menu-list .menu4{
  width:2.1rem;
  height: calc(2.1rem * (66 / 128));
  background-image: url('../../../assets/web-firehero/zh/h5/imgs/menu-4.png');
  top: 50%;
}

.webapp-box .menu-box .menu-list .menu5{
  background-image: url('../../../assets/web-firehero/zh/h5/imgs/menu-5.png');
  top: 59%;
}

.webapp-box .menu-box .menu-list .menu-line:after{
  content: "";
  position: absolute;
  width:9.5rem;
  height: calc(9.5rem * (19 / 562));
  background-image: url('../../../assets/web-firehero/common/h5/imgs/menu-line.png');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  -webkit-transform: translateX(-50%);
  left: 50%;
  top: 120%;
}

.webapp-box .menu-box .menu-list .menu-line {
}

.bg-page {
  position: relative;
  width:100%;
  height: 100%;
  overflow: hidden;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-page:after {
  position: absolute;
  z-index: 0;
  bottom: 0;
  content: "";
  width:100%;
  padding-top: calc( 100% * (343 / 1024));
  background-image: url('../../../assets/web-firehero/common/h5/imgs/bg-bottom.png');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg-page.bg-page-1{
  background-image: url('../../../assets/web-firehero/common/h5/imgs/bg-1.jpg');
}

.bg-page.bg-page-2{
  background-image: url('../../../assets/web-firehero/common/h5/imgs/bg-2.jpg');
}

.bg-page.bg-page-3{
  background-image: url('../../../assets/web-firehero/common/h5/imgs/bg-3.jpg');
}

.bg-page.bg-page-4{
  background-image: url('../../../assets/web-firehero/common/h5/imgs/bg-4.jpg');
}

.bg-page.bg-page-5{
  background-image: url('../../../assets/web-firehero/common/h5/imgs/bg-5.jpg');
}

.section .page {
  position: relative;
  z-index: 1;
  width:10rem;
  height: calc(10rem * (1386 / 640));
  margin: 0 auto;
  overflow: hidden;
}

.section .page.page1{
  overflow: visible;
}

@keyframes roleMove{
  0%{-webkit-transform:none;transform:none}
  50%{-webkit-transform:translateY(-3%);transform:translateY(-3%)}
  100%{-webkit-transform:none;transform:none}
}

.section .page.page1 .hero{
  position: absolute;
  z-index: 3;
  width: 12rem;
  height: calc(12rem * (828 / 764));
  background-image: url('../../../assets/web-firehero/common/h5/imgs/bg-1-hero.png');
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
  left: -20%;
  top: 20%;
  animation: roleMove 6s .6s linear infinite
}

.section .page.page1 .logo-bg {
  position: absolute;
  z-index: 10;
  width: 8rem;
  height: calc(8rem * (243 / 503));
  background: url('../../../assets/web-firehero/zh/h5/imgs/bg-1-logo.png') no-repeat;
  background-size: contain;
  -webkit-transform: translateX(-50%);
  left: 55%;
  top: 2.3rem;
}

.section .page.page1 .info{
  position: absolute;
  z-index: 8;
  width: 3rem;
  height: calc(3rem * (265 / 143));
  background: url('../../../assets/web-firehero/zh/h5/imgs/bg-1-info.png') no-repeat;
  background-size: contain;
  -webkit-transform: translateX(-50%);
  left: 78%;
  top: 6.5rem;
}

.page1 .logo-bg .play-btn {
  position: absolute;
  z-index: 2;
  width: 20%;
  height: 20%;
  background: url('../../../assets/web-firehero/common/pc/imgs/play-btn.png') no-repeat;
  background-size: contain;
  -webkit-transform: translateX(-50%);
  left: 69%;
  top: 80%;
}

.page1 .reservation-box {
  position: absolute;
  z-index: 10;
  width: 8.9rem;
  height: calc(8.9rem * (80 / 534));
  -webkit-transform: translateX(-50%);
  left: 50%;
  top: 15rem;
}

.page1 .reservation-box .download{
  position: absolute;
  z-index: 2;
  width: 45%;
  padding-top: calc(45% * (80 / 267));
  top: 0;
  background-size: 100% 100%;
  cursor: pointer;
  -webkit-transition: opacity .2s;
  transition: opacity .2s;
}
.page1 .reservation-box .download.ios-btn{
  left: 0%;
  background-image: url('../../../assets/web-firehero/zh/pc/imgs/ios-btn.png');
}
.page1 .reservation-box .download.android-btn{
  left: 55%;
  background-image: url('../../../assets/web-firehero/zh/pc/imgs/android-btn.png');
}

.page1 .rating{
  position: absolute;
  z-index: 2;
  width: 1.2rem;
  padding-top: calc(1.2rem * (621 / 620));
  top: 0;
  background-size: 100% 100%;
  cursor: pointer;
  -webkit-transition: opacity .2s;
  transition: opacity .2s;
  left: 8%;
  top: 17rem;
  background-image: url('../../../assets/web-firehero/common/game-rating.jpeg');
}

.page .section-next{
  position: absolute;
  z-index: 1;
  width: 1.5rem;
  height: calc(1.5rem * (65 / 89));
  background: url('../../../assets/web-firehero/common/h5/imgs/section-next.png') no-repeat;
  background-size: contain;
  transform: translate(-50%);
  left: 50%;
  top: 18rem;
}

.section .page.page2{
  overflow: visible;
}

.page2 .hero{
  position: absolute;
  z-index: 1;
  width: 16rem;
  height: calc(16rem * (1366 / 1024));
  background-image: url('../../../assets/web-firehero/common/h5/imgs/bg-2-hero.png');
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
  transform: translate(-50%);
  left: 50%;
}

.page2 .reward{
  position: absolute;
  z-index: 10;
  width: 6.3rem;
  height: calc(6.3rem * (1017 / 402));
  top: 8%;
  background-image: url('../../../assets/web-firehero/zh/h5/imgs/reward.png');
  background-size: cover;
  background-position: top left;
  background-repeat: no-repeat;
}

.page2 .reward .achieved{
  position: absolute;
  z-index: 11;
  width: 1.5rem;
  height:  calc(1.5rem * (140 / 151));
  background-image: url('../../../assets/web-firehero/zh/h5/imgs/achieved.png');
  background-size: cover;
  background-position: top left;
  background-repeat: no-repeat;
}

.page2 .reward .achieved.pos1{
  top: 47.5%;
  left: 17.3%;
}

.page2 .reward .achieved.pos2{
  top: 47.5%;
  left: 58.5%;
}

.page2 .reward .achieved.pos3{
  top: 87.5%;
  left: 17.3%;
}

.page2 .reward .achieved.pos4{
  top: 87.5%;
  left: 58.5%;
}


.section .page.page3{
  overflow: visible;
}

.page3 .hero-logo{
  position: absolute;
  z-index: 4;
  width: 4.3rem;
  height: calc(4.3rem * (110 / 270));
  background-image: url('../../../assets/web-firehero/zh/h5/imgs/hero-logo.png');
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
  transform: translate(-50%);
  left: 70%;
  top: 10%;
}

.page3 .swiper-box{
  position: absolute;
  z-index: 1;
  width: 10rem;
  height:  calc(10rem * (1366 / 1024));
  transform: translate(-50%);
  left: 50%;
  top: 18%;
}

.page3 .swiper-box .swiper-container{
  overflow: visible;
}


.page3 .swiper-box .hero-swipe{
  width: 100%;
  height: 100%;
}

.page3 .swiper-box .hero-swipe .hero-slide .hero{
  position: absolute;
  z-index: 2;
  width: 20rem;
  height: calc(20rem * (1366 / 1366));
  transform: translate(-50%);
  top: -25%;
  left: 50%;
}

.page3 .swiper-box .hero-swipe .hero-slide .info{
  position: absolute;
  z-index: 2;
  width: 6.5rem;
  height: calc(6.5rem * (540 / 384));
  transform: translate(-50%);
  top: 7%;
  left: 70%;
}

.page3 .swiper-box .hero-swipe .hero-slide .cv{
  position: absolute;
  z-index: 2;
  width: 4rem;
  height: calc(4rem * (46 / 264));
  transform: translate(-50%);
  top: 75%;
  left: 75%;
}

.page3 .hero-swiper-navigation {
  position: absolute;
  z-index: 5;
  width: 1.5rem;
  height: calc(1.5rem * (85 / 125));
  /*margin-top: 25.5%;*/
  top:45%;
  background-image: url('../../../assets/web-firehero/common/pc/imgs/hero-navigation.png');
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
  cursor: pointer;
}

.page3 .hero-swiper-navigation.hero-swiper-prev{
  left: 1%;
}

.page3 .hero-swiper-navigation.hero-swiper-next{
  right: 1%;
  transform: rotate(180deg);
}


.section .page.page4{
}

.page4 .worldview-box{
  position: absolute;
  z-index: 1;
  width: 9rem;
  height: calc(9rem * (749 / 562));
  top: 10%;
  left: 3%;
  background-image: url('../../../assets/web-firehero/zh/h5/imgs/bg-worldview.png');
  background-size: cover;
  background-position: top left;
  background-repeat: no-repeat;
}

@keyframes worldview-show{
  from {height: 0;}
  to {height: calc(4rem * (331 / 238));}
}

.page4 .worldview-box .worldview-text{
  position: absolute;
  z-index: 2;
  width: 4rem;
  height: calc(4rem * (331 / 238));
  top: 40%;
  left: 12.5%;
  background-image: url('../../../assets/web-firehero/zh/h5/imgs/worldview-text.png');
  background-size: cover;
  background-position: top left;
  background-repeat: no-repeat;
  animation: worldview-show 5s linear;
}

.section .page.page5{
}

.page5 .game-feature-logo{
  position: absolute;
  z-index: 1;
  width: 6rem;
  height: calc(6rem * (125 / 366));
  background-image: url('../../../assets/web-firehero/zh/h5/imgs/game-feature.png');
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
  transform: translate(-50%);
  left: 50%;
  top: 10%;
}

.page5 .swiper-box{
  position: absolute;
  width: 9.5rem;
  height: calc(9.5rem * (727 / (409 / 0.8)));
  transform: translate(-50%);
  left: 50%;
  top: 21%;
}

.page5 .swiper-box .feature-swipe{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.page5 .swiper-box .feature-swipe .feature-slide{
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  transform: scale(0.8) translate(-50%);
}

.page5 .feature-swipe .feature-slide img{
  position: relative;
  width:80%;
  height: 100%;
  margin: auto;
  display:block;
}

.page5 .feature-swiper-navigation {
  position: absolute;
  z-index: 1;
  width: 1rem;
  height: calc(1rem * (89 / 65));
  top:35%;
  background-image: url('../../../assets/web-firehero/common/h5/imgs/feature-navigation.png');
  background-size: contain;
  background-position: 0%;
  background-repeat: no-repeat;
  cursor: pointer;
}

.page5 .feature-swiper-navigation.feature-swiper-prev{
  right: 96%;
  transform: rotate(180deg) translate(-50%);
}

.page5 .feature-swiper-navigation.feature-swiper-next{
  left: 96%;
  transform: translate(-50%);
}


.dialog-box{
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  opacity: 1;
  background: rgba(0,0,0,0.7);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000,endColorstr=#99000000);
  transform: translate3d(0,0,1px);
  -webkit-transform: translate3d(0,0,1px);
}

/*视频弹窗*/
.dialog-box .dialog-video{
  position: relative; /*脱离文档流*/
  top: 30%; /*偏移*/
  margin:auto;
  width: 100%;
  height: 40%;
}

</style>



// WEBPACK FOOTER //
// src/pages/website/firehero/h5.vue